import React, { useEffect, useLayoutEffect } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { useIsLoggedIn } from '../../context/AuthMachine';
import { useCustomer } from '../../context/Customer';
import { useRedirectAfterAuthStateChange } from '../../navigation';
import {
  JoinOrSignInScreenContentEmbeddedFrameFlow,
  JoinOrSignInScreenContentHybridFlow,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const JoinOrSignInScreen = () => {
  const { customer } = useCustomer();
  const isLoggedIn = useIsLoggedIn();
  const redirectAfterAuthStateChange = useRedirectAfterAuthStateChange(true);
  const { redirect } = useLocalSearchParams<{ redirect?: string }>();
  const { replace } = useRouter();

  const isHybridAuthModeEnabled = useFeatureFlag('cels-2041-auth-hybrid-flow', {
    listenForChanges: true,
  });

  // ─── Effects ─────────────────────────────────────────────────────────

  useLayoutEffect(() => {
    if (!isLoggedIn) return;

    replace('/');
  }, [isLoggedIn, replace]);

  useEffect(() => {
    if (!isLoggedIn || !customer.id) return;

    redirectAfterAuthStateChange(redirect);
  }, [customer.id, isLoggedIn, redirect, redirectAfterAuthStateChange]);

  // ─────────────────────────────────────────────────────────────────────

  if (isLoggedIn) {
    return null;
  }

  if (isHybridAuthModeEnabled) {
    return <JoinOrSignInScreenContentHybridFlow />;
  }

  return <JoinOrSignInScreenContentEmbeddedFrameFlow />;
};
